import React, { FC } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, Stack, Button, Box } from "@mui/material";

interface RegisterThanksProps {}

const RegisterThanks: FC<RegisterThanksProps> = () => {
  const navigate = useNavigate();

  return (
    <Stack spacing={4} alignItems="center" maxWidth={800} mx="auto">
      {/* Alert Success */}
      <Alert
        severity="success"
        variant="outlined"
        sx={{
          borderColor: "success.main",
          bgcolor: "success.light",
          color: "success.contrastText",
          fontWeight: 500,
          width: "100%",
          maxWidth: 800,
        }}
      >
        Votre inscription a réussi.
      </Alert>

      {/* Alert Info */}
      <Alert
        severity="info"
        variant="outlined"
        sx={{
          borderColor: "info.main",
          bgcolor: "info.light",
          color: "info.contrastText",
          fontWeight: 500,
          width: "100%",
          maxWidth: 800,
        }}
      >
        Un e-mail de confirmation vous a été envoyé.
      </Alert>

      {/* Button to Register Another Player */}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          marginTop: "2rem",
        }}
      >
        <Button
          variant="contained"
          color="primary"
          sx={{
            padding: "10px 20px",
            fontWeight: 600,
            transition: "all 0.3s ease",
            "&:hover": {
              backgroundColor: "primary.dark",
              transform: "translateY(-2px)",
            },
          }}
          onClick={() => {
            navigate("/register");
          }}
        >
          Inscrire un autre joueur
        </Button>
      </Box>
    </Stack>
  );
};

export default RegisterThanks;
